import { useTranslation } from "react-i18next";
import styled from "styled-components";
import StaticPageLayout from "../../components/StaticPageLayout";

const SupportPage = () => {
    const { t } = useTranslation();

    return (
        <StaticPageLayout>
            <SupportWrapper>
                <h1>{t("Support")}</h1>
                <p>{t("Support intro")}</p>
                <p>{t("Support details")}</p>
                <p>{t("Support response time")}</p>
                <div className="contact-block">
                    <h2>{t("Contact details")}</h2>
                    <a href="tel:+380933893040">+380933893040</a>
                    <a href="mailto:support@likarweb.com">support@likarweb.com</a>
                </div>
            </SupportWrapper>
        </StaticPageLayout>
    );
};

export default SupportPage;

const SupportWrapper = styled.div`
    padding: 35px 40px 45px;
    display: flex;
    max-width: 820px;
    flex-direction: column;
    width: 100%;
    border-radius: 22px;
    background-color: #fff;
    border: 1px solid #e3ecff;
    box-shadow: 0 14px 45px rgba(16, 121, 255, 0.1);
    font-family: "Raleway";
    gap: 16px;
    margin: 0;
    position: relative;
    overflow: hidden;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 6px;
        background: linear-gradient(90deg, #1677ff 0%, #5b8dff 50%, #9ad0ff 100%);
    }

    @media (max-width: 490px) {
        padding: 20px 16px 28px;
    }

    h1 {
        font-size: 50px;
        font-weight: 800;
        line-height: 65px;
        color: #212121;
        margin-top: 10px;

        @media (max-width: 821px) {
            padding: 0 20px;
            font-size: 40px;
            line-height: 52px;
        }

        @media (max-width: 490px) {
            padding: 0 20px;
            font-size: 34px;
            line-height: 44px;
        }
    }

    h2 {
        font-size: 28px;
        font-weight: 700;
        line-height: 36px;
        font-family: "Raleway";
        color: #212121;

        @media (max-width: 821px) {
            padding: 0 20px;
            font-size: 24px;
            line-height: 32px;
        }
    }

    p,
    a {
        font-weight: 400;
        font-size: 18px;
        line-height: 27px;
        color: #212121;
        font-family: "Roboto";

        @media (max-width: 821px) {
            padding: 0 20px;
            font-size: 16px;
            line-height: 24px;
        }
    }

    .contact-block {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 8px;

        a {
            font-weight: 600;
            color: #1677ff;
        }
    }

`;
